// Categories
export const CARS_CATEGORY1_ID = 2500
export const VANS_AND_COMMERCIAL_CATEGORY1_ID = 2900
export const AUTOCARAVANS_AND_TRAILERS_CATEGORY1_ID = 3820
export const CLASSIC_AND_COMPETITION_CARS_CATEGORY1_ID = 3110
export const CARS_WITHOUT_LICENSE_CATEGORY1_ID = 4000

export const CATEGORIES_IDS = {
  AUTOCARAVANS_AND_TRAILERS: AUTOCARAVANS_AND_TRAILERS_CATEGORY1_ID,
  CARS: CARS_CATEGORY1_ID,
  CARS_WITHOUT_LICENSE: CARS_WITHOUT_LICENSE_CATEGORY1_ID,
  CLASSIC_AND_COMPETITION_CARS: CLASSIC_AND_COMPETITION_CARS_CATEGORY1_ID,
  VANS_AND_COMMERCIAL: VANS_AND_COMMERCIAL_CATEGORY1_ID
}

export const CATEGORIES_LEVEL_1 = {
  [CATEGORIES_IDS.AUTOCARAVANS_AND_TRAILERS]: {
    icon: 'carAutocaravan',
    id: CATEGORIES_IDS.AUTOCARAVANS_AND_TRAILERS,
    name: 'COMMON.CATEGORIES.AUTOCARAVANS_AND_TRAILERS'
  },
  [CATEGORIES_IDS.CARS]: {
    icon: 'car',
    id: CATEGORIES_IDS.CARS,
    name: 'COMMON.CATEGORIES.CARS'
  },
  [CATEGORIES_IDS.CARS_WITHOUT_LICENSE]: {
    icon: 'carMini',
    id: CATEGORIES_IDS.CARS_WITHOUT_LICENSE,
    name: 'COMMON.CATEGORIES.CARS_WITHOUT_LICENSE'
  },
  [CATEGORIES_IDS.CLASSIC_AND_COMPETITION_CARS]: {
    icon: 'carSport',
    id: CATEGORIES_IDS.CLASSIC_AND_COMPETITION_CARS,
    name: 'COMMON.CATEGORIES.CLASSIC_AND_COMPETITION_CARS'
  },
  [CATEGORIES_IDS.VANS_AND_COMMERCIAL]: {
    icon: 'carIndustrial',
    id: CATEGORIES_IDS.VANS_AND_COMMERCIAL,
    name: 'COMMON.CATEGORIES.VANS_AND_COMMERCIAL'
  }
}

// Categories with electric features
export const CATEGORIES_WITH_ELECTRIC_FEATURES = [CARS_CATEGORY1_ID, VANS_AND_COMMERCIAL_CATEGORY1_ID]
